import styled from 'styled-components';

export const YouStyledPageContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 0px 16px;
  box-sizing: border-box;
  background-color: ${({ $backgroundColor }) => $backgroundColor || 'transparent'};
  box-shadow:
    ${({ $showTopShadow }) =>
    $showTopShadow ? 'inset 0 8px 8px -8px rgba(0, 0, 0, 0.15)' : 'none'},
    ${({ $showBottomShadow }) =>
    $showBottomShadow ? 'inset 0 -8px 8px -8px rgba(0, 0, 0, 0.15)' : 'none'};
  transition: box-shadow 0.2s ease;
`;
